import AppSettingsService from '@/services/app-settings.service'

const state = {
  settings: null,
  landingSettingsFetched: false,
}

const mutations = {
  SET(state, payload) {
    state.settings = payload
  },
  SET_LANDING(state, payload) {
    if (!state.settings)
      state.settings = {}

    Object.assign(state.settings, payload)
    state.landingSettingsFetched = true
  }
}

const actions = {
  fetchLandingSettings: ({ commit, state }, payload) => {
    payload = payload || { force: false }

    if (state.settings && !payload.force || state.landingSettingsFetched)
      return state.settings?.colors || null

    return AppSettingsService.getLandingSettings(payload.customerCode).then(data => {
      if (data) {
        commit('SET_LANDING', data)
      }
      return data
    })
  },
  fetch: async ({ commit, state }, payload) => {
    payload = payload || { force: false }

    if (state.settings && !payload.force)
      return state.settings

    return AppSettingsService.getSettings().then(data => {
      commit('SET', data)
      return data
    })
  },
  sync: ({ commit, state, dispatch }, data) => {
    return AppSettingsService.updateSettings(data).then(x => {
      dispatch('fetch', { force: true })
    })
  }
}

const getters = {
  settings: (state, getters) => {
    return state.settings
  },
  iranValidityPrice: state => {
    return (state.settings || {}).iranValidityConfig?.price
  },
  landingSettings: (state, getters) => {
    return {
      siteTheme: state.settings?.siteTheme,
      themeSettings: state.settings?.themeSettings || null,
      phones: state.settings?.phones || '',
      agentOfficePhone: state.settings?.agentOfficePhone || '',
      address: state.settings?.address || '',
      shopLink: state.settings?.shopLink || '',
      shopTitle: state.settings?.shopTitle || '',
      email: state.settings?.email || '',
      businessTitle: state.settings?.businessTitle || '',
      enamadLink: state.settings?.enamadLink || '',
      etehadieLink: state.settings?.etehadieLink || '',
      samandehiLink: state.settings?.samandehiLink || '',
      anjomanSenfiLink: state.settings?.anjomanSenfiLink || '',
      kasboKarhayeInternetiTehranLink: state.settings?.kasboKarhayeInternetiTehranLink || '',
      applicationLink: state.settings?.applicationLink || '',
      whatsappLink: state.settings?.whatsappLink || '',
      telegramLink: state.settings?.telegramLink || '',
      instagramLink: state.settings?.instagramLink || '',
      telegramLink: state.settings?.telegramLink || '',
      rubikaLink: state.settings?.rubikaLink || '',
      aparatLink: state.settings?.aparatLink || '',
      calculatorType: state.settings?.calculatorType,
      agentFactorOnlinePaymentGateway: state.settings?.agentFactorOnlinePaymentGateway,
      hasRegisterOtpSms: state.settings?.hasRegisterOtpSms,
      inquiryPostalAddressInRegister: state.settings?.inquiryPostalAddressInRegister,
      inquiryPersonInfoInRegister: state.settings?.inquiryPersonInfoInRegister,
      inquiryBankInRegister: state.settings?.inquiryBankInRegister
    }
  },
  themeSettings: (state, getters) => {
    return state.settings?.themeSettings
  },
  profitPercent: state => {
    return (state.settings || {}).profitPercent
  },
  image: state => {
    return state.drawer.image === '' ? state.drawer.image : state.images[state.drawer.image]
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
